'use strict';
namespace Reviews {

    angular.module('reviews').config(($routeProvider: ng.route.IRouteProvider) => {

        $routeProvider.when('/review-hotel/preview/:bookingId/:userId/:token', <ng.route.IRoute>{
            templateUrl: 'partials/review/partialTemplate?type=preview',
            controllerAs: 'rp',
            controller: 'ReviewPreview',
            hideSiteFooter: TRPCONFIG.Domain.MybHideFooter,
            hideFooterToolbar: TRPCONFIG.Domain.MybHideFooter,
            hideSiteMailingListSignUp: TRPCONFIG.Domain.MybHideFooter
        });

        $routeProvider.when('/review-hotel/submitted/:hotelId', {
            templateUrl: 'partials/review/partialTemplate?type=submitted',
            controllerAs: 'rhs',
            controller: 'ReviewSubmitted'
        });

        $routeProvider.when('/review-hotel/:bookingId/:userId?/:token?', {
            templateUrl: 'partials/review/partialTemplate?type=reviewHotel',
            controllerAs: 'rh',
            controller: 'ReviewHotel'
        });

    });

}
